import { PATH_DELIMITER, ENROLMENT_ENROLMENT_RESULT_PATH } from '../../../constant/Constant';
import { defaultGridData } from '../../../module/component/TableBoxModule';
import { createAction, handleActions } from 'redux-actions';
import { call, put, takeEvery } from '@redux-saga/core/effects';
import { request } from '../../ApiModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { SET_NO_PAGE_GRID_DATA } from '../../component/TableNoPageBoxModule';

const ACTION_INIT = ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'ACTION_INIT';

const ACTION_ENROLMENT_RESULT_SEARCH =
    ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'ACTION_ENROLMENT_RESULT_SEARCH';

const ACTION_ENROLMENT_RESULT_REMOVE =
    ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'ACTION_ENROLMENT_RESULT_REMOVE';

const ACTION_ENROLMENT_RESULT_SEMESTER_INFO_SEARCH =
    ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'ACTION_ENROLMENT_RESULT_SEMESTER_INFO_SEARCH';

const ACTION_ENROLMENT_RESULT_BY_UNIVERSITY_SEARCH =
    ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'ACTION_ENROLMENT_RESULT_BY_UNIVERSITY_SEARCH';

const ACTION_ENROLMENT_RESULT_SEMESTER_USER_INFO_SEARCH =
    ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'ACTION_ENROLMENT_RESULT_SEMESTER_USER_INFO_SEARCH';

const HANDLE_ENROLMENT_RESULT = ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'HANDLE_ENROLMENT_RESULT';

const HANDLE_ENROLMENT_RESULT_BY_UNIVERSITY =
    ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'HANDLE_ENROLMENT_RESULT_BY_UNIVERSITY';

const HANDLE_ENROLMENT_RESULT_SEMESTER_INFO =
    ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'HANDLE_ENROLMENT_RESULT_SEMESTER_INFO';

const HANDLE_ENROLMENT_RESULT_ENROLMENT_VALID_STATUS =
    ENROLMENT_ENROLMENT_RESULT_PATH + PATH_DELIMITER + 'HANDLE_ENROLMENT_RESULT_ENROLMENT_VALID_STATUS';

export const actionInit = createAction(ACTION_INIT);
export const actionEnrolmentResultSearch = createAction(ACTION_ENROLMENT_RESULT_SEARCH);
export const actionEnrolmentResultRemove = createAction(ACTION_ENROLMENT_RESULT_REMOVE);
export const actionEnrolmentResultSemesterInfoSearch = createAction(ACTION_ENROLMENT_RESULT_SEMESTER_INFO_SEARCH);
export const actionEnrolmentResultByUniversitySearch = createAction(ACTION_ENROLMENT_RESULT_BY_UNIVERSITY_SEARCH);
export const actionEnrolmentResultSemesterUserInfoSearch = createAction(
    ACTION_ENROLMENT_RESULT_SEMESTER_USER_INFO_SEARCH,
);

export function* enrolmentResultSagas() {
    yield takeEvery(ACTION_ENROLMENT_RESULT_SEARCH, actionEnrolmentResultSearchSaga);
    yield takeEvery(ACTION_ENROLMENT_RESULT_REMOVE, actionEnrolmentResultRemoveSaga);
    yield takeEvery(ACTION_ENROLMENT_RESULT_BY_UNIVERSITY_SEARCH, actionEnrolmentResultByUniversitySearchSaga);
    yield takeEvery(ACTION_ENROLMENT_RESULT_SEMESTER_INFO_SEARCH, actionEnrolmentResultSemesterInfoSearchSaga);
    yield takeEvery(ACTION_ENROLMENT_RESULT_SEMESTER_USER_INFO_SEARCH, actionEnrolmentResultSemesterUserInfoSearchSaga);
}

function* actionEnrolmentResultSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/enrolment/semesters/${params.semesterId}/by-user`,
        params,
        callback,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: SET_NO_PAGE_GRID_DATA,
            payload: {
                ...result,
                rows: result.rows.map((row) => ({ ...row.courseInfo, courseTimes: row.courseTimes })),
            },
        });
    }
}

function* actionEnrolmentResultRemoveSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'delete',
        url: `/api/enrolment/semesters/${data.semesterId}/universities/${data.lessonUniversityCd}/subjects/${data.subjectId}/classes/${data.classNo}/users/${data.userId}/universitySubjects/${data.universitySubjectId}`,
        callback,
    });
}

function* actionEnrolmentResultByUniversitySearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/enrolment-university/semesters/${params.semesterId}`,
        params,
        callback,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: HANDLE_ENROLMENT_RESULT_BY_UNIVERSITY,
            payload: result.rows,
        });
    }
}

function* actionEnrolmentResultSemesterInfoSearchSaga({ payload: { params } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/semesters/${params.semesterId}`,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: HANDLE_ENROLMENT_RESULT_SEMESTER_INFO,
            payload: result,
        });
    }
}

function* actionEnrolmentResultSemesterUserInfoSearchSaga({ payload: { params } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/semester-user/semesters/${params.semesterId}/users/${params.userId}`,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: HANDLE_ENROLMENT_RESULT_ENROLMENT_VALID_STATUS,
            payload: result,
        });
    }
}

const initialState = {
    gridData: defaultGridData,
    univData: [],
    semesterInfo: {},
    semesterUserInfo: {},
};

const module = handleActions(
    {
        [HANDLE_ENROLMENT_RESULT]: (state, { payload: gridData }) => ({ ...state, gridData }),
        [HANDLE_ENROLMENT_RESULT_BY_UNIVERSITY]: (state, { payload: univData }) => ({ ...state, univData }),
        [HANDLE_ENROLMENT_RESULT_SEMESTER_INFO]: (state, { payload: semesterInfo }) => ({ ...state, semesterInfo }),
        [HANDLE_ENROLMENT_RESULT_ENROLMENT_VALID_STATUS]: (state, { payload: semesterUserInfo }) => ({
            ...state,
            semesterUserInfo,
        }),
    },
    initialState,
);

export default module;
